import ProvidedJobPostsForm from '../components/ProvidedJobPostsForm';
import { useEffect, useState } from 'react';

type InitialData = {
  title?: string;
  jobContentJson?: Array<{
    key: string;
    content?: string;
  }>;
};

export default function ProvidedJobPostsNewTemplate() {
  const [initialData, setInitialData] = useState<InitialData | undefined>(undefined);

  useEffect(() => {
    // sessionStorageからデータを取得
    const stored = sessionStorage.getItem('pdfImportInitialData');
    if (stored) {
      try {
        const data = JSON.parse(stored) as InitialData;
        setInitialData(data);
        // 使用後は削除
        sessionStorage.removeItem('pdfImportInitialData');
      } catch (e) {
        console.error('Failed to parse initial data from sessionStorage', e);
      }
    }
  }, []);

  return (
    <div>
      <section className="p-6 pt-3">
        <ProvidedJobPostsForm formType="create" initialData={initialData} />
      </section>
    </div>
  );
}
